/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { WebpageSelector } from "components/webpage-selector";
import { Logger } from "cms/utils/log/logger";

const WebpageSelectorWrapper = (props) => {
    const index = props?.index;
    const onWebpageChange = props?.onWebpageChange;     // onWebpageChange is called when a webpage is selected or changed
    const onWebpageRemove = props?.onWebpageRemove;     // onWebpageRemove is called when a webpage removed (empty the selection)
    const selectedData = props?.selectedData;
    const webpage = props?.webpage;
    const setWebpage = props?.setWebpage;
    const model = props?.model;
    const webpageGuid = props?.webpageGuid;
    const setWebpageGuid = props?.setWebpageGuid;
    const AddComponent = props?.AddComponent;
    const DisplayComponent = props?.DisplayComponent;
    const loadingWebpage = props?.loadingWebpage;
    // const setLoadingWebpage = props?.setLoadingWebpage;
    const defaultImage = props?.defaultImage;
    const defaultTitleDescription = props?.defaultTitleDescription;
    const changeTitle = props?.changeTitle;
    const changeDescription = props?.changeDescription;
    const filter = props?.filter;    // Filter is used to identify a how to alter the search query to limit results returned. Not required.
    const filterValue = props?.filterValue;
    
    const onSelectWebpage = async (webpage) => {
        Logger.debug("webpage", {webpage});
        setWebpage(webpage);
        setWebpageGuid(webpage?.guid);
        onWebpageChange(webpage);
    };
    
    const onWebpageRemoved = async () => {
        setWebpage(undefined);
        setWebpageGuid(undefined);
        onWebpageRemove();
    };

    return (
        <WebpageSelector
            index={index}
            AddComponent={AddComponent}
            DisplayComponent={DisplayComponent}
            // localStateWebpage={localStateWebpage}
            selectedData={selectedData}
            model={model}
            webpage={webpage}
            setWebpage={setWebpage}
            webpageGuid={webpageGuid}
            setWebpageGuid={setWebpageGuid}
            onSelectWebpage={onSelectWebpage}
            onWebpageRemoved={onWebpageRemoved}
            filter={filter}
            filterValue={filterValue}
            loadingWebpage={loadingWebpage}
            defaultImage={defaultImage}
            defaultTitleDescription={defaultTitleDescription}
            changeTitle={changeTitle}
            changeDescription={changeDescription}
        />
    );
};

export { WebpageSelectorWrapper };
